import * as S from './styles';
import Switch from '@components/Common/Switch';

import MultiCheckIcon from '@svgIcons/multi_check.svg';

export default {
    name: 'MultiSelectToggle',
    props: {
        allowMultiSelect: {
            type: Boolean,
            default: false,
        },
        handleUpdateAllowMultiSelect: {
            type: Function,
            default: () => {},
        },
    },
    render() {
        const { allowMultiSelect, handleUpdateAllowMultiSelect } = this;

        return (
            <S.ComponentWrapper>
                <div class="top-wrapper">
                    <div class="title">
                        <MultiCheckIcon class="multi-check-icon" />
                        <h3>{this.$t('NEW_DASHBOARD.enable_multi_select')}</h3>
                    </div>
                    <Switch
                        value={allowMultiSelect}
                        type="big"
                        onClick={() =>
                            handleUpdateAllowMultiSelect(!allowMultiSelect)
                        }
                    />
                </div>
            </S.ComponentWrapper>
        );
    },
};
